import axios from 'axios'

const baseURL = process.env.VUE_APP_PICA_CORE_API_BASE_URL

const publicClient = axios.create({
    baseURL,
    headers: {'X-Requested-With': 'XMLHttpRequest'},
})

const endpoint = (taskReference) => `/dashboard/v3/media/download/${taskReference}/`

export default {
    async fetchArchive(taskReference) {
        const response = await publicClient.get(endpoint(taskReference))
        return response.data
    },
}
